var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.elementTag,_vm._b({tag:"component",class:_vm.isLink ? _vm.linkClass : _vm.fallbackClass},'component',_vm.attributes,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }